export default {
  setAnswer(state, answer) {
    state.answer = answer
  },
  setIsSaving(state, isSaving) {
    state.isSaving = isSaving
  },
}
